export default __webpack_public_path__ + "static/media/mbfcTower.jpg?.fc5e484f";